import React, { useEffect } from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button, Callout, DataListItem } from '@node-space/ui-components'
import { useWalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { formDataAtom, transferErrorAtom } from './atoms/atoms'
import { useInternalTransferDetails } from './hooks/useInternalTransferDetails'

interface MoveConfirmProps {
  isLoading: boolean
  handleSubmit: () => void
  onBack: () => void
}

export const MoveConfirm = ({ isLoading, handleSubmit, onBack }: MoveConfirmProps) => {
  const { t } = useTranslation()
  const [walletAction, setWalletAction] = useWalletActionContext()
  const formValues = useAtomValue(formDataAtom)
  const transferError = useAtomValue(transferErrorAtom)
  const { onClose: handleClose } = walletAction || {}

  useEffect(() => {
    if (onBack) {
      setWalletAction({
        ...walletAction,
        onBack,
      })
    }
  }, [])

  const moveConfirmationDetails = useInternalTransferDetails(formValues)

  return (
    <Box paddingX={24} className="my-6 w-full space-y-4 text-gray-100">
      {!!transferError && <Callout variant="error">{transferError}</Callout>}
      <Box>
        {moveConfirmationDetails.map((row, index) => (
          <DataListItem
            key={index}
            id={row.testid}
            testId={row.testid}
            title={row.label}
            body={row.description}
          />
        ))}
      </Box>
      <Box className="flex justify-between pt-2">
        <Button variant="secondary" onClick={handleClose}>
          {t('cancel')}
        </Button>
        <Button onClick={handleSubmit} loading={isLoading}>
          {t('confirm')}
        </Button>
      </Box>
    </Box>
  )
}
